import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import ElevatedPaper from "../../../components/ElevatedPaper";
import Flex from "../../../components/Flex";
import LogOutModal from "../../../components/LogOutModal";
import { ScrollArea } from "../../../components/ScrollBar";
import NavBar from "../../../components/app/nav-bar/NavBar";
import {
  ADMIN_MENU,
  NAVBAR_PROFILE_OPTIONS,
} from "../../../constants/admin-layout";
import { NavDataType } from "../../../constants/common";
import useDisclosure from "../../../hooks/use-disclosure";

const AdminLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [anchorElUser, setAnchorElUser] = useState<HTMLElement | null>(null);
  const [activeTab, setActiveTab] = useState<string>(ADMIN_MENU[1].value);
  const logOutDisclosure = useDisclosure(false);

  useEffect(() => {
    setActiveTab(
      ADMIN_MENU.find(
        (item) =>
          location.pathname.startsWith(item.path ?? "#") ||
          item.children?.some((child) =>
            location.pathname.startsWith(child.path ?? "#")
          )
      )?.value ?? ADMIN_MENU[1].value
    );
  }, [handleCloseUserMenu]);

  function handleCloseUserMenu(submenu?: NavDataType) {
    submenu?.path && navigate(submenu.path);
    setAnchorElUser(null);
  }

  function onClickProfileData(profileData: NavDataType) {
    profileData.path && navigate(profileData.path);
    if (profileData.value === "log_out") {
      logOutDisclosure.open();
    }
  }

  function handleTabClick(
    menu: NavDataType,
    event: React.MouseEvent<HTMLElement>
  ) {
    menu?.children &&
      setAnchorElUser((prevAnchorEl) =>
        prevAnchorEl ? null : event.currentTarget
      );
    menu.path && navigate(menu.path);
  }

  return (
    <Flex flexDirection={"column"}>
      <NavBar
        view="admin"
        navOptions={ADMIN_MENU}
        anchorElUser={anchorElUser}
        active={activeTab}
        handleCloseUserMenu={handleCloseUserMenu}
        onClickMenuItem={handleTabClick}
        profileData={NAVBAR_PROFILE_OPTIONS}
        handleProfileClick={onClickProfileData}
      />

      <LogOutModal disclosureHost={logOutDisclosure} />

      <ElevatedPaper
        sx={{
          margin: "13px",
          padding: "16px",
          height: "auto",
          maxHeight: "90vh",
          minHeight: "calc(100vh - 4.5rem)",
        }}
      >
        <ScrollArea height={"auto"}>
          <Outlet />
        </ScrollArea>
      </ElevatedPaper>
    </Flex>
  );
};

export default AdminLayout;
